import { useTranslation } from '../../../i18n';
import { toPoints } from './scale';

const CAD2 = new Intl.NumberFormat('fr-CA', { style: 'currency', currency: 'CAD' });

export function ConfigSummaryBar({
  pendingCount,
  vehicleCost,
  revenuePct,
  teamsTargeted,
  teamsTotal,
}: {
  pendingCount: number;
  vehicleCost: number | null;
  revenuePct: number | null;
  teamsTargeted: number;
  teamsTotal: number;
}) {
  const { t } = useTranslation();

  const items: { label: string; value: string }[] = [
    {
      label: t('gest:admin.remuneration.config.summary.pending'),
      value: String(pendingCount),
    },
    {
      label: t('gest:admin.remuneration.config.summary.vehicle'),
      value:
        vehicleCost == null
          ? t('gest:admin.remuneration.config.summary.undefinedVehicle')
          : CAD2.format(vehicleCost),
    },
    {
      label: t('gest:admin.remuneration.config.summary.revenue'),
      value:
        revenuePct == null
          ? t('gest:admin.remuneration.config.summary.undefinedRevenue')
          : `${toPoints(revenuePct)} %`,
    },
    {
      label: t('gest:admin.remuneration.config.summary.teams'),
      value: t('gest:admin.remuneration.config.summary.teamsValue', {
        targeted: teamsTargeted,
        total: teamsTotal,
      }),
    },
  ];

  return (
    <dl className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
      {items.map((item) => (
        <div key={item.label} className="min-w-0">
          <dt className="text-chip text-slate-500 dark:text-slate-400">{item.label}</dt>
          <dd className="mt-0.5 text-body font-semibold text-slate-800 dark:text-slate-100">{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}
